import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: "'Fraunces', serif",
    body: "'Outfit', sans-serif",
  },
  colors: {
    brand: {
      bg: '#07070a',
      surface: '#0a0f1a',
      surface2: '#0e1520',
      surface3: '#131d2a',
      accent: '#00c3ff',
      accent2: '#0077ff',
      accent3: '#ff6b47',
      text: '#f0f0f5',
      muted: '#6b7fa0',
      border: 'rgba(0,195,255,0.12)',
    },
  },
  styles: {
    global: {
      'html, body': {
        bg: '#07070a',
        color: '#f0f0f5',
        fontFamily: "'Outfit', sans-serif",
        overflowX: 'hidden',
        scrollBehavior: 'smooth',
      },
      'h1, h2, h3, h4, h5': {
        fontFamily: "'Fraunces', serif",
        lineHeight: 1.15,
      },
      a: {
        color: 'inherit',
        textDecoration: 'none',
      },
      img: {
        maxWidth: '100%',
      },
      '*': {
        boxSizing: 'border-box',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontFamily: "'Outfit', sans-serif",
        fontWeight: 600,
        borderRadius: '8px',
      },
      variants: {
        primary: {
          bg: '#00c3ff',
          color: '#000',
          px: 6,
          py: 3,
          _hover: {
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 32px rgba(0,195,255,0.45)',
          },
        },
        ghost: {
          bg: 'transparent',
          color: '#f0f0f5',
          border: '1px solid rgba(0,195,255,0.2)',
          px: 5,
          py: 2.5,
          _hover: {
            borderColor: '#00c3ff',
            bg: 'rgba(0,195,255,0.08)',
            color: '#00c3ff',
          },
        },
        danger: {
          bg: '#ff4747',
          color: '#fff',
          _hover: { bg: '#ff2020' },
        },
      },
    },
    Input: {
      variants: {
        brand: {
          field: {
            bg: 'brand.surface2',
            border: '1px solid',
            borderColor: 'rgba(0,195,255,0.15)',
            color: 'brand.text',
            borderRadius: '8px',
            _placeholder: { color: 'brand.muted' },
            _focus: {
              borderColor: '#00c3ff',
              boxShadow: '0 0 0 1px #00c3ff',
            },
          },
        },
      },
      defaultProps: { variant: 'brand' },
    },
    Textarea: {
      variants: {
        brand: {
          bg: 'brand.surface2',
          border: '1px solid',
          borderColor: 'rgba(0,195,255,0.15)',
          color: 'brand.text',
          borderRadius: '8px',
          _placeholder: { color: 'brand.muted' },
          _focus: {
            borderColor: '#00c3ff',
            boxShadow: '0 0 0 1px #00c3ff',
          },
        },
      },
      defaultProps: { variant: 'brand' },
    },
    Select: {
      variants: {
        brand: {
          field: {
            bg: 'brand.surface2',
            border: '1px solid',
            borderColor: 'rgba(0,195,255,0.15)',
            color: 'brand.text',
            borderRadius: '8px',
            _focus: {
              borderColor: '#00c3ff',
            },
          },
        },
      },
      defaultProps: { variant: 'brand' },
    },
  },
});

export default theme;
